import React from 'react';
import { UserSelector } from '@/shared/components/user-selector/UserSelectorDropDown';
import { useManagerEmployees } from '@/shared/hooks/useEmployees';
import { useEmployeeContext } from '@/shared/contexts/EmployeeContext';

interface EmployeeFilterProps {
  selectedEmployeeId: string | undefined;
  onSelectionChange: (employeeId: string | undefined) => void;
}

export const EmployeeFilter: React.FC<EmployeeFilterProps> = ({
  selectedEmployeeId,
  onSelectionChange,
}) => {
  const currentEmployee = useEmployeeContext();

  const { data: employees = [] } = useManagerEmployees({
    managerId: currentEmployee._id,
  });

  const userSelectorEmployees = employees.map((emp) => ({
    id: emp._id,
    firstName: emp.firstName,
    lastName: emp.lastName,
    fullName: `${emp.firstName} ${emp.lastName}`,
    isActive: true,
    imageUrl: emp.imageUrl,
    role: emp.role,
  }));

  const handleSelectionChange = (employeeIds: string[]) => {
    console.log('employeeIds', employeeIds);
    onSelectionChange(employeeIds.length > 0 ? employeeIds[0] : undefined);
  };

  return (
    <UserSelector
      employees={userSelectorEmployees}
      selectedEmployees={selectedEmployeeId ? [selectedEmployeeId] : []}
      onSelectionChange={handleSelectionChange}
      multiSelect={false}
      variant="inline"
      className="w-full"
      showClearButton={true}
    />
  );
};
